module.exports = __webpack_public_path__ + "static/trig-chart-1@2x-2855ca6c5705d169a6bf31b7b5cc60db.png";